<div class="journey-icon" (click)="openJourneyList()">
  <div class="icon-container">
    <i class="fa fa-plus-square"></i>
    <p><b>Add Experience</b></p>
  </div>
</div>
